import { InputNetBillingCreditCard } from "@scrile/api-provider/dist/api/NetbillingPurchaseProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import paymentComponent from "./NetBilling.vue";
import { IntegrationModule } from "../types";

const integrationModule: IntegrationModule<InputNetBillingCreditCard | undefined> = {
  paymentComponent,
  purchase: async (data, billingDetails) => {
    const transaction: Transaction = await providers.NetbillingPurchaseProvider.purchaseDeposit({
      data: { ...data, billingDetails },
    });
    return {
      status: true,
      subjectPurchased: false,
      transaction,
    };
  },
  subscribe: async (data, billingDetails) => {
    const subscription: Subscription = await providers.NetbillingPurchaseProvider.purchaseRecurring({
      data: {
        ...data,
        billingDetails,
      },
    });
    return {
      status: true,
      subjectPurchased: false,
      subscription,
    };
  },
  allowSaveCard: true,
  name: $t("NetBilling"),
  logo: "/img/paymentSystems/netbilling.svg",
};

export const selector = (system: PaymentSystemPublic | null): boolean => {
  return system?.type === "netbilling" ?? false;
};

export default integrationModule;
